export default __webpack_public_path__ + "static/media/regulamento-compras-mario-ito.190d9b65.pdf";